import React from 'react';

export const SupportSection: React.FC = () => {
  return (
    <section id="report" className="flex flex-col gap-6 scroll-mt-8">
      <h2 className="text-3xl font-bold border-b border-zinc-700 pb-4">Report Issues</h2>
      {/* Reporting Issues */}
      <div className="border border-zinc-700 rounded-lg p-6">
        <div className="flex items-center gap-3 mb-4">
          <span className="bg-purple-600 text-white px-3 py-1 rounded-full text-sm font-semibold">
            Support
          </span>
          <span className="text-zinc-400 text-sm">Help Us Help You</span>
        </div>
        <h3 className="text-xl font-semibold mb-3">Reporting Issues</h3>
        <div className="space-y-3 text-zinc-400">
          <p>
            Found a bug that's not listed here? Help us fix it by reporting the issue with as much
            detail as possible.
          </p>
          <div className="space-y-2">
            <h4 className="text-white font-medium">📝 What to Include</h4>
            <ul className="list-disc space-y-1 ml-4">
              <li>Detailed description of the problem</li>
              <li>Steps to reproduce the issue</li>
              <li>Your browser and operating system</li>
              <li>Screenshots or screen recordings if helpful</li>
              <li>Any error messages you see</li>
            </ul>
          </div>
          <div className="space-y-2">
            <h4 className="text-white font-medium">📧 Contact Methods</h4>
            <ul className="list-disc space-y-1 ml-4">
              <li>
                Email:{' '}
                <a href="mailto:support@tone3000.com" className="text-white hover:underline">
                  support@tone3000.com
                </a>
              </li>
              <li>
                Discord:{' '}
                <a
                  href="https://discord.gg/wEV8uEWDnb"
                  className="text-white hover:underline"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Join our community server
                </a>{' '}
                for real-time support
              </li>
              <li>
                GitHub: Report issues on our{' '}
                <a
                  href="https://github.com/tone-3000"
                  className="text-white hover:underline"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  open source repositories
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};
